import { render } from "./ManageActions.vue?vue&type=template&id=5ca55aff"
import script from "./ManageActions.vue?vue&type=script&lang=js"
export * from "./ManageActions.vue?vue&type=script&lang=js"

import exportComponent from "/home/siddharth/customerAdminFrontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__